/* eslint-disable */
import $ from 'jquery';
/* eslint-enable */

export default function () {

	$('.photo-gallery .more').click(function() {
		$(this).closest('.photo-gallery').find('.col-12.d-none').slice(0,4).removeClass('d-none');
		
		if ($(this).closest('.photo-gallery').find('.col-12.d-none').length == 0)
			$(this).hide();
		
		
		return false;
	});
}